import { useMutation, useQueryClient } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { addRosterQualifications } from 'RestAPIs/qualifications';

type AddRosterQualificationsVariables = {
  costCenterId: number;
  qualificationId: string;
};

const useAddRosterQualifications = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, AddRosterQualificationsVariables>(
    ({ costCenterId, qualificationId }) =>
      addRosterQualifications(costCenterId, qualificationId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([
          'rosterQualifications',
          'list',
          variables.costCenterId
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddRosterQualifications;
